import { render, staticRenderFns } from "./MarkHistoryDialog.vue?vue&type=template&id=73ddf035"
import script from "./MarkHistoryDialog.vue?vue&type=script&lang=js"
export * from "./MarkHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports